import React, { lazy } from 'react';
import { Section } from './Section';
import { CheckIcon } from 'lucide-react';
const items = ['10 Recetas de Desayunos Energizantes', '10 Recetas de Almuerzos Saciantes y Nutritivos', '10 Recetas de Cenas Livianas para un buen descanso', '10 Postres y Snacks Saludables sin culpa', 'Guía visual de Alimentos Aliados y Enemigos', 'Tips de cocina rápida para la semana'];
export const Included = () => {
  return <Section className="bg-brand-900 text-stone-50 relative overflow-hidden" data-id="element-148">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-brand-800 rounded-full blur-3xl opacity-50" data-id="element-149"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-brand-700 rounded-full blur-3xl opacity-30" data-id="element-150"></div>

      <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-151">
        <div data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-153">
            ¿Qué vas a encontrar exactamente adentro?
          </h2>
          <p className="text-brand-100 text-lg mb-8" data-id="element-154">
            Todo lo que necesitas para empezar hoy mismo, organizado de forma
            clara, visual y directa al grano.
          </p>

          <ul className="space-y-4" data-id="element-155">
            {items.map((item, idx) => <li key={idx} className="flex items-center gap-3 bg-brand-800/50 p-3 rounded-lg border border-brand-700/50" data-id="element-156">
                <div className="bg-brand-500 rounded-full p-1 shrink-0" data-id="element-157">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-158" />
                </div>
                <span className="font-medium text-brand-50" data-id="element-159">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-160">
          <img src="https://cdn.shopify.com/s/files/1/0829/1431/2411/files/EBOOK_PLAN_TIROIDES_360.png?v=1779798823&width=600&quality=80&format=webp" srcSet="https://cdn.shopify.com/s/files/1/0829/1431/2411/files/EBOOK_PLAN_TIROIDES_360.png?v=1779798823&width=400&quality=80&format=webp 400w, https://cdn.shopify.com/s/files/1/0829/1431/2411/files/EBOOK_PLAN_TIROIDES_360.png?v=1779798823&width=600&quality=80&format=webp 600w" sizes="(max-width: 768px) 100vw, 50vw" alt="Recetario Plan Tiroides 360" width={600} height={600} loading="lazy" decoding="async" className="object-contain w-full max-h-[500px] drop-shadow-2xl" data-id="element-161" />
          <div className="absolute -bottom-6 -right-6 bg-accent-600 text-white p-6 rounded-2xl shadow-xl transform rotate-3" data-id="element-162">
            <p className="text-sm uppercase tracking-wider font-bold mb-1" data-id="element-163">
              Formato Digital
            </p>
            <p className="text-2xl font-serif font-bold" data-id="element-164">Acceso Inmediato</p>
          </div>
        </div>
      </div>
    </Section>;
};